import {Injectable, OnInit} from '@angular/core';
import {SipConditionGroupApiService} from '../../api/settings/call-flow-configurations/sip-condition-group/sip-condition-group-api.service';
import _ from 'lodash';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SipHeadersService {
  data;

  constructor(private sipConditionGroupApiService: SipConditionGroupApiService) { }

  getSipConditionTemplate(): Observable<any> {
    if (!_.isNil(this.data)) {
      return new Observable((observer) => {
        observer.next(this.data);
      });
    }

    return this.sipConditionGroupApiService.getSipConditionTemplate().pipe(
      map(sipConditionData => {
        this.data = this.generateHeaderData(sipConditionData);

        return this.data;
      })
    );
  }

  private generateHeaderData(sipConditionData: any): any {
    const headerStructure: any = [];
    const headerOperators: any = {};

    const manipulationHeaderStructure: any = [];
    const manipulationHeaderActions = sipConditionData.manipulationActionsByHeader;

    const flatten = (data: any, str: any) => {
      let strTemp = '';
      for (const property of data) {
        strTemp = str ? `${str}.${property.name}` : property.name;

        if (!_.isEmpty(property.children)) {
          flatten(property.children, strTemp);

          if (!_.isEmpty(property.operators)) {
            this.setHeaderData(headerStructure, headerOperators, strTemp, property);
            if (!_.isNil(manipulationHeaderActions[strTemp.toLowerCase()]) &&
              !_.isEmpty(manipulationHeaderActions[strTemp.toLowerCase()])) {
              manipulationHeaderActions[strTemp.toLowerCase()] = manipulationHeaderActions[strTemp.toLowerCase()];
              manipulationHeaderStructure.push(strTemp);
            }
          }
        } else {
          this.setHeaderData(headerStructure, headerOperators, strTemp, property);
          if (!_.isNil(manipulationHeaderActions[strTemp.toLowerCase()]) &&
            !_.isEmpty(manipulationHeaderActions[strTemp.toLowerCase()])) {
            manipulationHeaderActions[strTemp.toLowerCase()] = manipulationHeaderActions[strTemp.toLowerCase()];
            manipulationHeaderStructure.push(strTemp);
          }
        }
      }
    };

    flatten(sipConditionData.headers, '');

    return {
      headerStructure,
      headerOperators,
      manipulationHeaderStructure,
      manipulationHeaderActions,
      conditionOps: sipConditionData.conditionOps,
      manipulationOps: sipConditionData.manipulationOps,
      requestMethodOps: sipConditionData.requestMethodOps,
      contentTypeOps: sipConditionData.contentTypeOps
    };
  }

  generateSubjectManipulationSuggestions(header): any {
    return this.generateSubjectSuggestions(header, 'manipulation');
  }

  generateSubjectSuggestions(header, type = 'condition'): any {
    header = header.toLowerCase();
    let subjectSuggestions;
    const headerStructure = (type === 'manipulation') ?
      this.data.manipulationHeaderStructure : this.data.headerStructure;

    subjectSuggestions = headerStructure.filter(i => i.toLowerCase().startsWith(header.toLowerCase()));
    subjectSuggestions = subjectSuggestions.map(i => {
      const nextDotIndex = i.indexOf('.', header.length);
      return (nextDotIndex === -1) ? i : i.substring(0, nextDotIndex);
    });

    subjectSuggestions = subjectSuggestions.filter(i => i !== '');
    subjectSuggestions = new Set(subjectSuggestions);

    return subjectSuggestions;
  }

  generateActionsForHeader(header): any {
    return this.generateOperatorsForHeader(header, 'manipulation');
  }

  generateOperatorsForHeader(header, type = 'condition'): any {
    if (_.isNil(header)) {
      return null;
    }

    header = header.toLowerCase();
    let headerOptions;
    let itemOptions;

    if (type === 'manipulation') {
      headerOptions = this.data.manipulationHeaderActions;
      itemOptions = this.data.manipulationOps;
    } else {
      headerOptions = this.data.headerOperators;
      itemOptions = this.data.conditionOps;
    }

    let operatorOptions;
    const headerType = header.substring(0, header.lastIndexOf('.')).toLowerCase();
    operatorOptions = headerOptions[header] ? headerOptions[header] : null;

    if (!operatorOptions && (header.length > (headerType.length + 1))) {
      operatorOptions = headerOptions[`${headerType}.otherheader`] || headerOptions[`${headerType}.fieldname`] || null;
    }

    if (!_.isNil(operatorOptions)) {
      operatorOptions = operatorOptions.map(operator =>
        itemOptions.find(operatorOption => operatorOption.value === operator));
    }

    return operatorOptions;
  }

  private setHeaderData(headerStructure, headerOperators, strTemp, property): any {
    headerStructure.push(strTemp);
    headerOperators[strTemp.toLowerCase()] = property.operators;
  }
}
